import { render } from "./RequestView.vue?vue&type=template&id=0c4209d8&scoped=true"
import script from "./RequestView.vue?vue&type=script&lang=js"
export * from "./RequestView.vue?vue&type=script&lang=js"

import "./RequestView.vue?vue&type=style&index=0&id=0c4209d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4209d8"]])

export default __exports__